import React, { useState, Fragment } from "react";
import {
  TableRow,
  TableCell,
  Stack,
  IconButton,
  Typography,
} from "@mui/material";
import { useQuery } from "@apollo/client";
import { NumericFormat } from "react-number-format";
//date picker
import moment from "moment";
//Icons
import { IoAddCircleOutline } from "react-icons/io5";
//Srcs
import { currencyFormat } from "../../Function/DynamicFn";
import ListPayment from "./ListPayment";

export default function ListExpense({
  mainItem,
  disbursementList,
  setDisbursementList,
  requireField,
  setRequireField,
}) {
  // console.log("first disbursementList::", disbursementList)
  //================================== list Payment ===================================
  const handleAddPayments = (mainKey, subKey) => {
    let newdisbursementList = disbursementList;
    newdisbursementList?.map((d) => {
      if (d.key === mainKey) {
        d?.items?.map((item) => {
          let newPayments = item.payments;
          if (item?.key === subKey) {
            newPayments.push({
              subKey: item?.key,
              paymentDate: moment(),
              paymentMethod: "Cash",
              pricePaidKHR: 0,
              pricePaidUSD: 0,
              key: "payments" + Date.now(),
            });
            item.payments = newPayments;
          }
        });
      }
    });
    // console.log("newdisbursementList::", newdisbursementList)
    setDisbursementList([...newdisbursementList]);
  };

  //=============================== Delete List Pyament ================================
  const deletePaymentsList = (mainKey, subKey, key) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          d?.items?.map((item) => {
            let newPayments = item?.payments?.filter((p) => p.key !== key);
            item.payments = newPayments;
          });
        }
      });
    }
    setDisbursementList([...newdisbursementList]);
  };

  //=================================== Change Date =======================================
  const setUpdatePaymentDate = (mainKey, subKey, key, paymentDate) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          d?.items?.map((item) => {
            if (item?.key === subKey) {
              let newPayments = item?.payments;
              newPayments?.map((i) => {
                if (i.key === key) {
                  i.paymentDate = paymentDate;
                }
              });
              d.payments = newPayments;
            }
          });
        }
      });
    }

    setDisbursementList([...newdisbursementList]);
    if (paymentDate !== "" || paymentDate !== undefined) {
      setRequireField(false);
    } else {
      setRequireField(true);
    }
  };

  //=================================== Change Payment Method ================================
  const setUpdatePaymentMethod = (mainKey, subKey, key, paymentMethod) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          d?.items?.map((item) => {
            if (item?.key === subKey) {
              let newPayments = item?.payments;
              newPayments?.map((i) => {
                if (i.key === key) {
                  i.paymentMethod = paymentMethod;
                }
              });
              d.payments = newPayments;
            }
          });
        }
      });
    }

    setDisbursementList([...newdisbursementList]);
    if (paymentMethod !== "" || paymentMethod !== undefined) {
      setRequireField(false);
    } else {
      setRequireField(true);
    }
  };

  //================================= Change PriceKHR =====================================
  const setUpdatePaymentPriceKh = (mainKey, subKey, key, pricePaidKHR) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          d?.items?.map((item) => {
            if (item?.key === subKey) {
              let newPayments = item?.payments;
              newPayments?.map((i) => {
                if (i.key === key) {
                  i.pricePaidKHR = parseFloat(pricePaidKHR);
                }
              });
              d.payments = newPayments;
            }
          });
        }
      });
    }

    setDisbursementList([...newdisbursementList]);
    if (pricePaidKHR !== "" || pricePaidKHR !== 0) {
      setRequireField(false);
    } else {
      setRequireField(true);
    }
  };

  //============================= Change PriceUSD =======================================
  const setUpdatePaymentPriceUsd = (mainKey, subKey, key, pricePaidUSD) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          d?.items?.map((item) => {
            if (item?.key === subKey) {
              let newPayments = item?.payments;
              newPayments?.map((i) => {
                if (i.key === key) {
                  i.pricePaidUSD = parseFloat(pricePaidUSD);
                }
              });
              d.payments = newPayments;
            }
          });
        }
      });
    }
    setDisbursementList([...newdisbursementList]);
    if (pricePaidUSD !== "" || pricePaidUSD !== 0) {
      setRequireField(false);
    } else {
      setRequireField(true);
    }
  };

  //============================ End list Payment ===============================

  const ListItems = mainItem?.items?.map((item) => {
    // console.log("sub_item::", item);
    // console.log("mainItem::", mainItem)
    return (
      <Fragment key={item?.key}>
        <TableRow>
          <TableCell className="disbursement-body-title">
            <Typography className="select-title">
              {item?.invNo ? item?.invNo : "N/A"}
            </Typography>
          </TableCell>
          <TableCell className="disbursement-body-title">
            <Typography className="select-title">
              {item?.invDate
                ? moment(item?.invDate).format("DD-MM-YYYY")
                : "N/A"}
            </Typography>
          </TableCell>
          <TableCell className="disbursement-body-title">
            <Typography className="select-title">
              {item?.description ? item?.description : "N/A"}
            </Typography>
          </TableCell>
          <TableCell className="disbursement-body-title">
            <Typography className="select-title">
              {item?.supplierName ? item?.supplierName : "N/A"}
            </Typography>
          </TableCell>
          <TableCell className="disbursement-body-title">
            <Typography className="select-title">
              {item?.qty ? item?.qty : "0"}
            </Typography>
          </TableCell>
          <TableCell className="disbursement-body-title">
            <Typography className="select-title">
              {item?.exchangeRate
                ? currencyFormat(item?.exchangeRate) + " ៛"
                : "0.00 ៛"}
            </Typography>
          </TableCell>
          <TableCell className="disbursement-body-title">
            <Typography className="select-title">
              {item?.priceKHR
                ? currencyFormat(item?.priceKHR) + " ៛"
                : "0.00 ៛"}
            </Typography>
          </TableCell>
          <TableCell className="disbursement-body-title">
            <Typography className="select-title">
              {item?.priceUSD
                ? currencyFormat(item?.priceUSD) + " $"
                : "0.00 $"}
            </Typography>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell className="disbursement-body-title" colSpan={4}>
            <Stack
              sx={{
                borderBottom: "1px solid #0f81c2",
                width: "100%",
                marginTop: "10px",
              }}
              direction="row"
              justifyContent="space-between"
            >
              <Stack direction="column" justifyContent="center">
                <Typography className="field-title-sub-kh">
                  ការទូទាត់
                </Typography>
              </Stack>
              <IconButton
                onClick={() => handleAddPayments(mainItem?.key, item?.key)}
              >
                <IoAddCircleOutline className="close-icon" />
              </IconButton>
            </Stack>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell
            className="disbursement-header-title"
            sx={{ width: "10%" }}
          >
            កាលបរិច្ឆេទ
          </TableCell>
          <TableCell
            className="disbursement-header-title"
            sx={{ width: "10%" }}
          >
            ទូទាត់តាមរយៈ
          </TableCell>
          <TableCell
            className="disbursement-header-title"
            sx={{ width: "10%" }}
          >
            លុយខ្មែរ
          </TableCell>
          <TableCell
            className="disbursement-header-title"
            sx={{ width: "10%" }}
          >
            លុយដុល្លារ
          </TableCell>
        </TableRow>
        <ListPayment
          mainItem={mainItem}
          subItem={item}
          deletePaymentsList={deletePaymentsList}
          requireField={requireField}
          setRequireField={setRequireField}
          setUpdatePaymentDate={setUpdatePaymentDate}
          setUpdatePaymentMethod={setUpdatePaymentMethod}
          setUpdatePaymentPriceKh={setUpdatePaymentPriceKh}
          setUpdatePaymentPriceUsd={setUpdatePaymentPriceUsd}
        />
      </Fragment>
    );
  });

  return <>{ListItems}</>;
}
